// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a1d4a291","164":"849495c6","254":"d19cc2bc","301":"41c0b8ec","444":"6ad591aa","453":"43775016","721":"86f91596"}[chunkId] + ".chunk.js";
};